import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../../data/site';
interface BuyButtonProps {
  label: string;
  href?: string;
  size?: 'md' | 'lg' | 'xl';
  variant?: 'primary' | 'gold';
  className?: string;
}
export function BuyButton({
  label,
  href = '#oferta',
  size = 'md',
  variant = 'primary',
  className = ''
}: BuyButtonProps) {
  const sizing = {
    md: 'px-7 py-4 text-[14.5px]',
    lg: 'px-8 py-4 text-[15.5px] sm:px-11 sm:py-5 sm:text-[17px]',
    xl: 'px-8 py-5 text-[16px] sm:px-12 sm:py-6 sm:text-[18px]'
  }[size];
  const palette = variant === 'gold' ? 'bg-gold-500 text-sage-900 hover:bg-gold-400 shadow-[0_16px_40px_-14px_rgba(154,128,57,0.75)]' : 'bg-terracotta-500 text-cream hover:bg-terracotta-600 shadow-[0_16px_40px_-14px_rgba(152,80,46,0.7)]';
  return <a href={href} data-editable={href === CHECKOUT_URL ? "checkout-link" : undefined} className={`group inline-flex items-center justify-center gap-3 rounded-full font-semibold tracking-[0.01em] transition-[background-color,transform,box-shadow] duration-200 ease-soft hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-sage-700 ${sizing} ${palette} ${className}`} data-id="element-227" data-mp="2khug50vzzfvq">
      <span data-id="element-228" data-mp="2ekucbw81x2fj">{label}</span>
      <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-soft group-hover:translate-x-1" aria-hidden="true" data-id="element-229" data-mp="2ejj9bymfjyph" />
    </a>;
}